var map = {
	"./Google-SignIn.svg": 58670,
	"./addconsignee.svg": 28372,
	"./arrow-up.1.svg": 49314,
	"./arrow-up.svg": 70045,
	"./checkboxtick.1.svg": 78069,
	"./checkboxtick.svg": 99174,
	"./column-picker.svg": 25563,
	"./containers.svg": 2942,
	"./dashboard_empty_state_icon.svg": 92294,
	"./destination.1.svg": 45973,
	"./destination.svg": 65606,
	"./dot.1.svg": 89112,
	"./dot.svg": 38919,
	"./dropdown_arrow.svg": 87115,
	"./fill_arrow.1.svg": 82120,
	"./fill_arrow.svg": 94167,
	"./fill_arrow_white.1.svg": 19374,
	"./fill_arrow_white.svg": 49505,
	"./filtericon.svg": 38555,
	"./generic_logo.svg": 30413,
	"./halt.svg": 2819,
	"./hover-shape.1.svg": 48627,
	"./hover-shape.svg": 55752,
	"./icon-column.1.svg": 4083,
	"./icon-column.svg": 82248,
	"./icon-no-lanes-bg.svg": 19339,
	"./icon-search.svg": 88238,
	"./icon-sort-arrow.svg": 3458,
	"./icon-sort.svg": 40166,
	"./invalid-material.svg": 42651,
	"./invoicetriangle.1.svg": 30984,
	"./invoicetriangle.svg": 62999,
	"./loading_split.1.svg": 7000,
	"./loading_split.svg": 24135,
	"./logo.1.svg": 18988,
	"./logo.svg": 83411,
	"./maricologo.svg": 61008,
	"./mdm.svg": 53666,
	"./menu.svg": 45203,
	"./minus.1.svg": 39197,
	"./minus.svg": 36638,
	"./ms-symbollockup_signin_dark.svg": 4541,
	"./noindents.1.svg": 55219,
	"./noindents.svg": 72616,
	"./optima-settings.svg": 89426,
	"./optima.svg": 97156,
	"./orders.svg": 40741,
	"./payment.svg": 6932,
	"./paymentemptystage.1.svg": 65480,
	"./paymentemptystage.svg": 22007,
	"./plus.svg": 2006,
	"./setting.svg": 31726,
	"./source.svg": 68649,
	"./transporterlogo.svg": 8389,
	"./truck-small.svg": 77889,
	"./truck.svg": 93779,
	"./valid-invalid.svg": 28517,
	"./valid-material.svg": 20578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90052;